export default __webpack_public_path__ + "static/media/images/explode.1799296f.jpg";